// libs
import React, { memo, useMemo, useRef } from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// components
import Menu from '@/components/Menu';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './Tooltip.module.scss';
const ARROW_OPACITY = 0.8;
function Tooltip({ content, contentClassName, children, arrowProps, inline = true, }) {
    const menuApiRef = useRef(null);
    const tooltipProps = useMemo(() => {
        return {
            content,
            contentClassName,
        };
    }, [content, contentClassName]);
    const combinedArrowProps = useMemo(() => {
        return Object.assign({ opacity: ARROW_OPACITY }, arrowProps);
    }, [arrowProps]);
    const onMouseEnter = () => {
        if (menuApiRef.current) {
            !menuApiRef.current.isOpen && menuApiRef.current.open();
        }
    };
    const onMouseLeave = () => {
        if (menuApiRef.current) {
            menuApiRef.current.isOpen && menuApiRef.current.close();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { inline: inline, showArrow: true, ref: menuApiRef, Content: TooltipContainer, contentProps: tooltipProps, arrowProps: combinedArrowProps },
            React.createElement("span", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children))));
}
function TooltipContainer({ content, contentClassName, }) {
    const renderContent = () => {
        return typeof content === 'string' ? (React.createElement(Text, { variant: DlsFontVariants.body_B2_Bold, color: DlsColorTokens.text_inverse_Highest_Emphasis }, content)) : (content);
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: cx(styles.containerContent, contentClassName) }, renderContent())));
}
export default memo(Tooltip);
